// Evidence side-panel VIEW-MODEL (pure). CLEARLY LABELED as a deterministic sort,
// NOT a fabricated "relevance" score.
//
// The Outcome Spine / journal carry no `relevance` field, so we never invent one.
// We sort by a real, present field (`as_of` recency by default, or `|impact|`) and
// return the human-readable basis of that sort so the UI can label it honestly.
//
// Evidence row shape (services/outcomes/adapters/recommendations.py:build_outcome):
//   { collection, ref_id, field, value, as_of }

export const EVIDENCE_SORTS = {
  recency: {
    key: "recency",
    label: "Sorted by recency (evidence.as_of)",
    field: "as_of",
  },
  impact: {
    key: "impact",
    label: "Sorted by |numeric value| (evidence.value)",
    field: "value",
  },
};

function tsMillis(v) {
  if (!v) return null;
  const t = Date.parse(v);
  return Number.isNaN(t) ? null : t;
}

function absNum(v) {
  const n = typeof v === "number" ? v : parseFloat(v);
  return Number.isNaN(n) ? null : Math.abs(n);
}

// Returns { rows, sortLabel }. `rows` is a NEW array (input is not mutated).
// Rows with a null sort key are placed last, preserving their original order
// (stable) so nothing is silently dropped or reordered arbitrarily.
export function sortEvidence(evidence, by = "recency") {
  const mode = EVIDENCE_SORTS[by] || EVIDENCE_SORTS.recency;
  const rows = Array.isArray(evidence) ? evidence.slice() : [];

  const keyOf = (row) =>
    mode.field === "as_of" ? tsMillis(row.as_of) : absNum(row.value);

  const decorated = rows.map((row, i) => ({ row, i, k: keyOf(row) }));
  decorated.sort((a, b) => {
    if (a.k == null && b.k == null) return a.i - b.i;
    if (a.k == null) return 1;
    if (b.k == null) return -1;
    if (a.k === b.k) return a.i - b.i;
    return b.k - a.k; // desc: most recent / largest magnitude first
  });

  return { rows: decorated.map((d) => d.row), sortLabel: mode.label };
}
